import { gql } from '@apollo/client';
import { client } from '../../context/ApolloContextProvider/client';
import type {
	GetAuthedUserForRedux_GetAuthedUserQuery,
	GetAuthedUserForRedux_GetAuthedUserQueryVariables,
} from '#types';
import {
	getAuthedUserFlattenedUserFieldsFragment,
	type FlattenedUser,
} from '../../types/user';

const getAuthedUserForReduxQuery = gql`
	query getAuthedUserForRedux_getAuthedUser($where: UserWhereUniqueInput!) {
		getAuthedUser(where: $where) {
			...getAuthedUserFlattenedUserFields
		}
	}
	${ getAuthedUserFlattenedUserFieldsFragment }
`;

export const mapAuthedUserToReduxUser = (
	authedUser: NonNullable<
		GetAuthedUserForRedux_GetAuthedUserQuery['getAuthedUser']
	>
) =>
	( {
		...authedUser,
		...( authedUser.clientUser || authedUser.superAdmin || authedUser.orgUser ),
		isLoggedIn: true,
	} as FlattenedUser );

export const getAuthedUserForRedux = async ( email: string, token: string ) => {
	const response = await client.query<
		GetAuthedUserForRedux_GetAuthedUserQuery,
		GetAuthedUserForRedux_GetAuthedUserQueryVariables
	>( {
		query: getAuthedUserForReduxQuery,
		variables: {
			where: { email },
		},
		context: { headers: { Authorization: `Bearer ${ token }` } },
	} );

	if ( !response.data?.getAuthedUser ) {
		return undefined;
	}

	return mapAuthedUserToReduxUser( response.data.getAuthedUser );
};
